/**
 * Read-only model metadata: asset ID, current LOD tier, and resolved file name.
 */
export function ObjectModelInfo({
  objectId,
  lod,
  resolvedModelUrl,
}: {
  objectId: string;
  lod: string;
  resolvedModelUrl?: string;
}) {
  return (
    <div className="mb-3 pb-2 border-b border-sands-100">
      <p className="text-[10px] font-medium text-sands-500 uppercase tracking-wider mb-1.5">
        Model
      </p>
      <div className="space-y-1">
        <div className="flex items-center gap-2 text-xs">
          <span className="text-sands-400 w-10 shrink-0">ID</span>
          <span className="text-sands-600 truncate font-mono text-[11px]">
            {objectId}
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <span className="text-sands-400 w-10 shrink-0">LOD</span>
          <span className="px-1.5 py-0.5 bg-sands-100 text-sands-600 rounded text-[10px] font-mono font-medium">
            {lod}
          </span>
        </div>
        {resolvedModelUrl && (
          <div className="flex items-center gap-2 text-xs">
            <span className="text-sands-400 w-10 shrink-0">File</span>
            <span
              className="text-sands-600 truncate font-mono text-[11px]"
              title={resolvedModelUrl}
            >
              {decodeURIComponent(
                resolvedModelUrl.split("/").pop()?.split("?")[0] ?? "unknown",
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
